import { OnInit, Input, OnChanges, Component, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { File64 } from './file64.interf';
import { stringify } from 'querystring';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Component({
  selector: 'sx-file-import',
  templateUrl: './fileImport.component.html',
  styleUrls: ['./fileImport.component.css']
})

export class sxFileImportComponent implements OnInit, OnChanges {

  @Input() supported: string[]; // formatos soportados
  @Input() fileLegend: string;

  // Evento cuando el usuario acepta el cambio de imagen
  @Output() theFile: EventEmitter<File64> = new EventEmitter();
  @Output() availableButton: EventEmitter<boolean> = new EventEmitter();

  file: File = null;
  edited = false;
  localFile: string;
  hasValidExtention: boolean = true;
  extentionErrorMessage: string;


  // file64: File64 = {
  //   fileData: '',
  //   fileName: '',
  //   extention: '',
  // };

  suportedString: string;

  constructor(private modalService: NgbModal, private sxTranslationService: SxTranslationService) { }

  ngOnInit() {
    this.localFile = 'None';
    this.suportedString = this.supported.join(';');
    this.fileLegend = this.fileLegend !== null && this.fileLegend !== undefined ? this.fileLegend : 'Choose File';
    this.extentionErrorMessage = this.generateExtentionErrorMessage();
  }

  ngOnChanges(changes) {
    if (changes.localFile != null) {
      this.localFile = changes.localFile.currentValue;
    }
  }

  /**
   * Abre el File Chooser (File Dialog)
   */

  generateExtentionErrorMessage(): string {
    if(this.supported){
    
    let resp: string = this.sxTranslationService.getResource('FILE_EXTENTION_NOT_SUPPORTED'); 

    resp = `${resp} ${this.supported.join(' , ')}.`;

    return resp;
    }
    return null;
  }

  openFileDialog() {
    $('#fileLoader').click();
  }

  restablecerUploader() {
    this.edited = false;
  }

  /**
   * Callback que se llama cuando el usuario selecciona una imagen
   * desde el File Chooser o cierra el File Chooser sin seleccionar nada
   */
  onFileChange(event) {
    const selectedAfile = event.target.files && event.target.files.length > 0;
    if (selectedAfile) {
      this.file = event.target.files[0];

      const fileExtension = this.file.name ? this.file.name.split('.').pop().replace(/^/, '.') : '';

      // Si el tipo de archivo subido no es valido, retornamos
      if (this.supported.indexOf(fileExtension) < 0) {
        this.hasValidExtention = false;
        this.availableButton.emit(true);
        this.localFile = "None";
        return;
      }
      else{
        this.hasValidExtention = true;
        this.availableButton.emit(false); 
      }

      this.localFile = this.file.name;
      this.edited = true; // only true if there is any file selected
    }
    this.restablecerUploader();
    this.emitFile();

  }


  /**
   * Emite que se ha cambiado la imagen
   */
  async emitFile() {
    // Emito el archivo!
    if (this.file != null) {      
      const reader = new FileReader();
      let file64: File64 = {
          fileData: '',
          fileName: '',
          extention: '',
        };
      // Se lee la imagen con un reader para mostrar el preview      
      reader.readAsDataURL(this.file);
      file64.fileName = this.file.name;
      file64.extention = this.file.type;
          reader.onload = (e: any) => {
          file64.fileData = e.target.result;
           this.theFile.emit(file64);
      };
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/sxFileImport/fileImport.component.ts